var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTableDuotone = function SvgTableDuotone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#9FAFC3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M4 18h40M16 6v36M13.6 6h20.8c3.36 0 5.04 0 6.324.654a6 6 0 0 1 2.622 2.622C44 10.56 44 12.24 44 15.6v16.8c0 3.36 0 5.04-.654 6.324a6 6 0 0 1-2.622 2.622C39.44 42 37.76 42 34.4 42H13.6c-3.36 0-5.04 0-6.324-.654a6 6 0 0 1-2.622-2.622C4 37.44 4 35.76 4 32.4V15.6c0-3.36 0-5.04.654-6.324a6 6 0 0 1 2.622-2.622C8.56 6 10.24 6 13.6 6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F0F8FF",
    d: "M7.276 6.654C8.56 6 10.24 6 13.6 6H16v12H4v-2.4c0-3.36 0-5.04.654-6.324a6 6 0 0 1 2.622-2.622"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#516B89",
    d: "m7.276 6.654.454.891zM4.654 9.276l.891.454zM16 6h1a1 1 0 0 0-1-1zm0 12v1h1v-1zM4 18H3a1 1 0 0 0 1 1zm9.6-12V5c-1.664 0-2.971 0-4.022.085-1.063.087-1.95.267-2.756.678l.454.891.454.891c.477-.243 1.072-.39 2.01-.467C10.692 7.001 11.904 7 13.6 7zM4 15.6h1c0-1.697 0-2.909.078-3.86.077-.938.224-1.533.467-2.01l-.891-.454-.891-.454c-.41.806-.591 1.693-.678 2.756C3 12.628 3 13.936 3 15.6zm3.276-8.946-.454-.891a7 7 0 0 0-3.059 3.06l.891.453.891.454A5 5 0 0 1 7.73 7.545zM13.6 6v1H16V5h-2.4zM16 6h-1v12h2V6zm0 12v-1H4v2h12zM4 18h1v-2.4H3V18z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#9FAFC3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M4 26h40M4 34h40"
  })));
};
export default SvgTableDuotone;